// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"115":"0471623e","320":"6f129721","670":"821ac49c"}[chunkId] + ".js";
};